import * as React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './Shape.css';

const types = {
    grey: style.grey,
    blue: style.blue
};

export const Shape = ({className, type, animate, ...rest}) => (
    <div
        className={cx(
            style.shape,
            type,
            className,
            animate
        )}
        role="presentation"
        {...rest}
    />
);

export const ShapeGrey = (props) => <Shape type={types.grey} {...props}/>;
export const ShapeBlue = (props) => <Shape type={types.blue} {...props}/>;

Shape.propTypes = {
    animate: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string.isRequired
};

Shape.defaultProps = {
    type: types.grey,
    animate: "rotation slow"
};